import { useEffect } from 'react'
import { config } from '../../../config'
import { useShouldRedirectToSchedulingV2 } from '../../../hooks'

const SchedulingV2Redirect = () => {
  const shouldRedirect = useShouldRedirectToSchedulingV2()
  const schedulingV2Url = config.SCHEDULING_V2_URL

  useEffect(() => {
    if (shouldRedirect) {
      const targetUrl = new URL(window.location.pathname + window.location.search + window.location.hash, schedulingV2Url)
      window.location.replace(targetUrl.toString())
    }
  }, [schedulingV2Url, shouldRedirect])

  return null
}

export { SchedulingV2Redirect }
